// removed by extract-text-webpack-plugin
module.exports = {"btnCart":"food__btnCart___bVNTE","modal":"food__modal___zgoVc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Food/food.css
// module id = 160
// module chunks = 0